import { NestedIntlProvider } from "@eroad/i18n/NestedIntlProvider";

import translations from "../translations";

/**
 * Must not be used outside this package.
 */
const UILibraryIntlProvider = ({ children }: React.PropsWithChildren<unknown>): JSX.Element => (
  <NestedIntlProvider
    enAU={translations.enAU}
    enNZ={translations.enNZ}
    enUS={translations.enUS}
    frCA={translations.frCA}
  >
    {children}
  </NestedIntlProvider>
);

export { UILibraryIntlProvider };
